import Vue from 'vue';
import Router from 'vue-router';
import home from '../pages/home';
import task from '../pages/task';
Vue.use(Router);
const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [{
      path: '/',
      redirect:'/home'
    },
    {
      path: '/home',
      component: home,
      meta: {
        index: 2
      },
    },
    {
      path: '/task',
      component: task,
      meta: {
        index: 3
      },
    }
  ],
});
// 判断是否需要进入首页 DON'T USE
// router.beforeEach((to, from, next) => {
//   let chosenCoupon = storage.getLocalStorage('Black_Friday_chosenCoupon')
//   let hasChosen = storage.getLocalStorage('Black_Friday_hasChosen')
//   next()
//   if(chosenCoupon || hasChosen){
//     next({
//       path: '/sales'
//     })
//   }else{
//     next()
//   }
// })
export default router


// WEBPACK FOOTER //
// ./src/router/index.js